import { withZod } from '@remix-validated-form/with-zod'
import { z } from 'zod'
import { zfd } from 'zod-form-data'

export const pmsConfigValidator = withZod(
  z
    .object({
      newPatientCalculation: zfd.repeatable(z.array(zfd.text()).min(1, `At least one rule must be selected`)),
      eligibleProcedureTransactions: zfd.repeatable(z.array(zfd.text())).optional(),
      excludeParentsFromNewPatients: z
        .string()
        .transform((value) => value === `true`)
        .optional(),
      transactionBrokenCodes: zfd.repeatable(z.array(zfd.text())).optional(),
      appointmentCompletionStatuses: zfd.repeatable(z.array(zfd.text())).optional(),
      removeNewPatientBeforeMigration: z.string().optional(),
      migrationDate: z
        .string()
        .optional()
        .refine(
          (val) => {
            if (!val) return true
            return !isNaN(Date.parse(val))
          },
          { message: `Please select a valid date` },
        ),
    })
    .superRefine((data, ctx) => {
      const isEnabled = data.removeNewPatientBeforeMigration === `true`
      if (isEnabled && !data.migrationDate) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: `Please Input a correct date following mm/dd/yyyy`,
          path: [`migrationDate`],
        })
      }
    })
    .transform((data) => ({
      ...data,
      removeNewPatientBeforeMigration: data.removeNewPatientBeforeMigration === `true`,
      transactionBrokenCodes: data.transactionBrokenCodes,
      appointmentCompletionStatuses: data.appointmentCompletionStatuses,
      eligibleProcedureTransactions: data.eligibleProcedureTransactions,
    })),
)
